// @flow
import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router'
import OpportunityDate from './OpportunityDate'
import type { OpportunityType } from '../types/OpportunityType'
import OpportunityPage from '../pages/OpportunityPage'
import styles from './opportunityListItem.less'

const OpportunityListItem = ({
  item,
  to,
  isOpen,
}: {
  item: OpportunityType,
  to: string,
  isOpen: boolean,
}) => {
  const {
    id,
    name,
    organization,
    submissionCount,
    galleryViewEnabled,
    galleryViewVotingEnabled,
    galleryViewVoteCount,
    startDateUtc,
    expireDateUtc,
    live,
  } = item
  return (
    <div
      className="list-group-item"
      style={{
        position: 'relative',
      }}
    >
      <Link className={styles.item} to={to}>
        <Row>
          <Col sm={3}>
            <strong>{name}</strong>
          </Col>
          <Col sm={3}>
            {organization.name}
          </Col>
          <Col sm={3}>
            <OpportunityDate
              startDateUtc={startDateUtc}
              expireDateUtc={expireDateUtc}
              live={live}
            />
          </Col>
          <Col sm={3}>
            {submissionCount} submissions
            {galleryViewEnabled ? ' | Gallery ' : ''}
            {galleryViewVotingEnabled ? `| ${galleryViewVoteCount} votes` : ''}
          </Col>
        </Row>
      </Link>
      {isOpen ? <OpportunityPage params={{ id }} showNav={false} /> : null}
      <Link
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
        }}
        to={`/opportunity/${id}`}
      >
        <span className={'glyphicon glyphicon-new-window'} />
      </Link>
    </div>
  )
}

export default OpportunityListItem



// WEBPACK FOOTER //
// ./src/components/OpportunityListItem.js